import React from 'react';
import { Layout } from '../components/layout/Layout';
import { PageHero, ContentSection, SEOContent, CTASection } from '../components/shared';
import { pageHeroImages, featureImages } from '../data/mock';

export const Checkup35Page = () => {
  return (
    <Layout>
      <PageHero
        title="Check-up 35: Ihr Rundum-Blick"
        subtitle="Die systematische Gesundheitsuntersuchung für ein langes, gesundes Leben."
        backgroundImage={pageHeroImages.checkup35}
        ctaText="Online buchen"
      />

      <ContentSection
        title="Was beinhaltet der Check-up 35?"
        content="Alle drei Jahre haben gesetzlich Versicherte ab 35 Anspruch auf diesen Check. Wir untersuchen Blutwerte (Cholesterin, Blutzucker), den Urinstatus und führen eine Ganzkörperuntersuchung durch. Ziel ist die Früherkennung von Volkskrankheiten wie Diabetes, Herz-Kreislauf-Erkrankungen oder Nierenleiden."
        image={featureImages.checkup35}
        backgroundColor="white"
      />

      <SEOContent
        title="Gesundheits-Check-up ab 35 in Diez"
        content="Die Gemeinschaftspraxis Dres. von Bergh bietet den Check-up 35 zur Früherkennung von Herz-Kreislauf-Erkrankungen, Diabetes und Nierenerkrankungen an."
      />

      <CTASection
        title="Termin für Check-up buchen"
        buttonText="Online buchen"
      />
    </Layout>
  );
};

export default Checkup35Page;
